import React from 'react';

export const ImpactLogo = ({ width = '800px' }) => (
  <svg viewBox="0 0 358.31 93.12" style={{ width, height: 'auto' }}>
    <defs>
      <style>{`.impact-blue { fill: #0068ff; } .impact-white { fill: #fff; }`}</style>
    </defs>
    <g>
      <path className="impact-white" d="M0,0h19.39v72.09H0V0Z"/>
      <path className="impact-white" d="M84.52,72.09v-39.68l-12.82,39.68h-14.14l-12.82-39.88v39.88h-17.87V0h22.52l15.45,48.27L80.38,0h22.42v72.09h-18.28Z"/>
      <path className="impact-white" d="M110,0h26.96c5.65,0,10.35.64,14.09,1.92,3.74,1.28,6.7,3.01,8.89,5.2,2.19,2.19,3.72,4.73,4.59,7.62.87,2.9,1.31,5.99,1.31,9.29s-.46,6.55-1.36,9.54c-.91,3-2.47,5.62-4.7,7.88-2.22,2.26-5.17,4.02-8.83,5.3-3.67,1.28-8.26,1.92-13.78,1.92h-8.38v23.43h-18.78V0ZM128.78,33.22h8.28c4.04,0,6.85-.76,8.43-2.27,1.58-1.51,2.37-3.79,2.37-6.82s-.81-5.25-2.42-6.66c-1.62-1.41-4.44-2.12-8.48-2.12h-8.18v17.87Z"/>
      <path className="impact-white" d="M211.63,19.21l25.04,72.09h-20.09l-4.14-13.83h-24.33l-4.04,13.83h-19.49l25.04-72.09h22.01ZM192.85,62.02h14.84l-7.37-24.84-7.47,24.84Z"/>
      <path className="impact-white" d="M318.12,35.67h-20.8v-16.46h60.99v16.46h-20.8v55.64h-19.39v-55.64Z"/>
    </g>
    <path className="impact-white" d="M265.58,76.46c-2.09,0-3.99-.37-5.71-1.11-1.72-.74-3.2-1.95-4.44-3.64-1.25-1.68-2.21-3.89-2.88-6.61-.67-2.73-1.01-6.04-1.01-9.95,0-14.07,4.61-21.1,13.83-21.1,1.88,0,3.5.29,4.85.86,1.35.57,2.47,1.35,3.38,2.32.91.98,1.63,2.14,2.17,3.48.21.53.4,1.09.58,1.66h19.93c-1.39-7.91-4.53-14.04-9.45-18.37-5.01-4.41-11.96-6.61-20.85-6.61-5.86,0-10.96.94-15.3,2.83-4.34,1.89-7.98,4.51-10.91,7.88-2.93,3.37-5.12,7.39-6.56,12.07-1.45,4.68-2.17,9.84-2.17,15.5s.71,10.59,2.12,15.2c1.41,4.61,3.53,8.57,6.36,11.86,2.83,3.3,6.39,5.86,10.7,7.67,4.31,1.82,9.39,2.73,15.25,2.73,5.18,0,9.73-.72,13.63-2.17,3.9-1.45,7.17-3.43,9.79-5.96s4.64-5.5,6.06-8.94c1.41-3.43,2.25-7.13,2.52-11.11h-19.79c-1.01,7.67-5.05,11.51-12.12,11.51Z"/>
    <polygon className="impact-blue" points="157.36 91.31 187.97 0 178.83 0 148.22 91.31 157.36 91.31"/>
  </svg>
);

export const OptioLogoFull = () => (
  <svg viewBox="0 0 421.13 134.89" className="h-10 w-auto opacity-60">
    <defs>
      <style>{`.optio-blue { fill: #0068ff; } .optio-white { fill: #fff; }`}</style>
    </defs>
    <g>
      <path className="optio-white" d="M59.17,67.79c6.16,0,11.2-5.05,11.2-11.2s-5.05-11.2-11.2-11.2-11.2,5.05-11.2,11.2,5.05,11.2,11.2,11.2Z"/>
      <path className="optio-white" d="M52.56,71.37h0c-1.73,0-1.73,1.73-1.73,1.73v59.62c0,1.19.97,2.17,2.17,2.17h13.29c1.19,0,2.17-.97,2.17-2.17v-43.81c0-9.17-7-16.66-15.95-17.5l.04-.04h.01Z"/>
      <path className="optio-blue" d="M56.77.06C27.18,1.92,2.87,25.44.25,54.95c-2.62,29.37,15.81,54.79,41.86,63.12v-32.11c-8.99-6.55-14.4-17.54-12.75-29.77,1.91-14.08,13.56-25.34,27.73-26.89,19.05-2.04,35.04,12.75,35.04,31.28,0,11.08-5.76,20.77-14.44,26.36v31.63c25.16-7.35,43.55-30.56,43.55-58.03,0-34.73-29.29-62.64-64.5-60.42h.04v-.04h0v-.02h-.01Z"/>
      <path className="optio-white" d="M166.43,27.79c-19.48,0-35.22,15.74-35.22,35.17s15.8,35.17,35.22,35.17,35.22-15.74,35.22-35.17-15.8-35.17-35.22-35.17ZM166.43,81.26c-10.09,0-18.33-8.21-18.33-18.24s8.21-18.24,18.33-18.24,18.33,8.21,18.33,18.24-8.21,18.24-18.33,18.24h0Z"/>
      <path className="optio-white" d="M373.22,27.79c-19.48,0-35.22,15.74-35.22,35.17s15.8,35.17,35.22,35.17,35.22-15.74,35.22-35.17-15.8-35.17-35.22-35.17ZM373.22,81.26c-10.09,0-18.33-8.21-18.33-18.24s8.21-18.24,18.33-18.24,18.33,8.21,18.33,18.24-8.21,18.24-18.33,18.24Z"/>
      <path className="optio-white" d="M324.16,27.54c6.3,0,11.44-5.14,11.44-11.44s-5.14-11.44-11.44-11.44-11.44,5.14-11.44,11.44,5.14,11.44,11.44,11.44Z"/>
      <path className="optio-white" d="M237.41,28.1c-18.67,1.24-32.81,17.4-32.81,36.07v56.45c9.3,0,16.9-7.53,16.9-16.84v-10.6c7.17,4.33,15.91,6.3,25.3,4.53,14.45-2.81,25.83-14.76,27.91-29.35,3.18-22.55-15.01-41.69-37.3-40.23h0v-.06h0v.03h0ZM239.86,81.37c-10.09,0-18.33-8.21-18.33-18.24s8.21-18.24,18.33-18.24,18.33,8.21,18.33,18.24-8.21,18.24-18.33,18.24Z"/>
      <path className="optio-white" d="M317.44,31.22h0c-1.77,0-1.77,1.77-1.77,1.77v60.95c0,1.24.98,2.19,2.19,2.19h13.58c1.24,0,2.19-.98,2.19-2.19v-44.75c0-9.36-7.17-17.04-16.28-17.88l.06-.06s.03-.03.03-.03Z"/>
      <path className="optio-white" d="M309.15,31.58h-11.89v-8.15c0-9.36-7.17-17.04-16.28-17.88h0c-1.77,0-1.77,1.77-1.77,1.77v86.58c0,1.24.98,2.19,2.19,2.19h13.58c1.24,0,2.19-.98,2.19-2.19v-47.2h11.89c1.29,0,2.28-1.04,2.28-2.28v-10.6c0-1.29-1.04-2.28-2.28-2.28h.06l.03.03h0Z"/>
      <path className="optio-white" d="M411.87,32.82v.98h-2.87v7.48h-1.18v-7.48h-2.87v-.98h6.92,0Z"/>
      <path className="optio-white" d="M412.91,32.82h1.66l2.45,7.17,2.45-7.17h1.66v8.46h-1.1v-7.11l-2.45,7.17h-1.18l-2.45-7.17v7.11h-1.1v-8.46h.08-.03.01Z"/>
    </g>
  </svg>
);

export const SlideWrapper = ({ slide, children, background }) => (
  <>
    {background}
    <div className="slide-wrapper">
      <div className="slide animate-fade-in" data-testid={`slide-${slide.id}`}>
        {children}
      </div>
    </div>
  </>
);

export const GlassCard = ({ children, className = '', style = {}, delay = 0 }) => (
  <div
    className={`relative rounded-2xl backdrop-blur-md border border-white/[0.08] animate-slide-up ${className}`}
    style={{
      background: 'linear-gradient(135deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.02) 100%)',
      animationDelay: `${delay}s`,
      ...style
    }}
  >
    {children}
  </div>
);

export const SectionLabel = ({ children, color = '#0068ff', delay = 0 }) => (
  <div className="animate-fade-in" style={{ animationDelay: `${delay}s` }}>
    <span
      className="text-xs font-bold uppercase tracking-[0.3em] px-4 py-1.5 rounded-full"
      style={{ color, background: `${color}15`, border: `1px solid ${color}30` }}
    >
      {children}
    </span>
  </div>
);
